<template>
  <div class="nj-grid">
    <nj-question-dialog
      ref="removeQuestionDialog"
      title="Excluir Caixas de Saída"
      text="Deseja realmente excluir a caixas de saída?"
    />
    <div class="header">
      <span class="title">Listagem de Caixas de Saída</span>
      <v-form @submit.prevent="search()">
        <v-text-field
          append-icon="mdi-magnify"
          placeholder="Pesquisar"
          outlined
          autofocus
          hide-details
          dense
          class="ma-0 pa-0"
          v-model="searchTerm"
        >
        </v-text-field>
      </v-form>
      <v-btn
        small
        color="primary"
        title="Novo Caixas de Saída"
        elevation="0"
        to="/outboxes/new"
      >
        <v-icon left> mdi-plus </v-icon>
        Novo
      </v-btn>
    </div>
    <v-data-table
      :headers="headers"
      :items="items"
      class="nj-table"
      :loading="loading"
      :options.sync="options"
      loading-text="Buscando..."
      ref="OutboxDataTable"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:item.updated_at="{ item }">
        {{ item.updated_at | njDateFormat(null, 'DD/MM/YYYY HH:mm') }}
      </template>
      <template v-slot:item.controls="{ item }">
        <div style="width: 160px">
          <v-btn
            :to="{ name: 'OutboxShow', params: { id: item.id } }"
            title="Visualizar"
            icon
          >
            <v-icon color="green">mdi-eye</v-icon>
          </v-btn>
          <v-btn
            :to="{ name: 'OutboxEdit', params: { id: item.id } }"
            title="Editar"
            icon
          >
            <v-icon color="orange">mdi-square-edit-outline</v-icon>
          </v-btn>
          <v-btn @click="remove(item)" title="Remover" icon>
            <v-icon color="red">mdi-delete</v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import Api from '@/resources/NajaSocialApi'
// import OutboxEnum from '@/enumerations/task_scheduler_enum'

export default {
  name: 'Outboxes',
  data: () => ({
    searchTerm: '',
    loading: false,
    items: [],
    operations: [],
    options: {},
    headers: [
      { text: 'Nome', value: 'name' },
      { text: 'Tipo', value: 'output_type_humanize' },
      { text: 'Última modificação', value: 'updated_at' },
      { text: 'Ações', value: 'controls', sortable: false },
    ],
  }),

  filters: {
    outputType: function (value) {
      return value ? value.split('_').join(' ') : ''
    },
  },

  mounted() {
    this.search()
  },

  methods: {
    remove(item) {
      if (!this.$hasPermission('naja_app_roles_destroy')) {
        alert('Acesso negado')
        return
      }

      this.$refs.removeQuestionDialog.open({
        onConfirm: () => {
          this.$refs.removeQuestionDialog.toggleLoading()
          Api.outboxes
            .destroy(item.id)
            .then(() => {
              this.search()
            })
            .catch(error => {
              if (error.response) {
                // this.$toast.show('Erro ao remover caixa de saída', 'error')
              } else {
                throw error
              }
            })
            .finally(() => {
              this.$refs.removeQuestionDialog.close()
            })
        },
      })
    },

    search() {
      this.loading = true

      const query = {
        q: {
          s: ['created_at desc'],
          name_cont: this.searchTerm,
        },
      }

      Api.outboxes
        .search(query)
        .then(response => {
          this.items = response.data.outboxes
        })
        .catch(error => {
          throw error
        })
        .finally(() => {
          this.loading = false
          this.$scrollTop()
        })
    },
  },
}
</script>
